"use strict";

module.exports = function (href) {
  var l = document.createElement("a");
  return l.href = href, l;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImdldExvY2F0aW9uLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJocmVmIiwibCIsImRvY3VtZW50IiwiY3JlYXRlRWxlbWVudCJdLCJtYXBwaW5ncyI6Ijs7QUFBQUEsTUFBQUEsQ0FBT0MsT0FBUEQsR0FBaUIsVUFBU0UsSUFBVCxFQUFTQTtBQUN4QixNQUFJQyxDQUFBQSxHQUFJQyxRQUFBQSxDQUFTQyxhQUFURCxDQUF1QixHQUF2QkEsQ0FBUjtBQUVBLFNBREFELENBQUFBLENBQUVELElBQUZDLEdBQVNELElBQVRDLEVBQ09BLENBQVA7QUFBT0EsQ0FIVEgifQ==